import React, { useEffect } from "react";
import { Box, Button } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
// background image now served from public/images/login-bg.jpg
import accellorLogo from "../../assets/images/accellorAI-Logo.svg";
import styles from "../Login/login.module.scss";

const Login = () => {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/landing", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className={styles.loginPageContainer}>
      <div className={styles.splitContainer}>
        <div className={styles.rightSection}>
          <Box className={styles.rightContent}>
            <div className={styles.logoContainer}>
              <img
                src={accellorLogo}
                alt="The Shelf logo"
                className={styles.logoImage}
              />
            </div>
            <div>
              <p className={styles.tagline}>
                Built for an AI-native enterprise. Designed for impact.
              </p>
              <p className={styles.subtagline}>Elevate how work gets done.</p>
              <p className={styles.description}>
                Intelligent AI agents designed for control and performance.
              </p>
            </div>
            <div className={styles.getStartedBtn}>
              <Button
                variant="contained"
                onClick={login}
                data-testid="login-button"
                className={styles.loginButton}
              >
                Get Started
              </Button>
            </div>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Login;
